// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/graph/signal_binding.proto (package mochabugapis.adapt.graph, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import type { Value, ValueJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { SignalDescriptor, SignalDescriptorJson } from "./signal_descriptor_pb";
import { file_mochabugapis_adapt_graph_signal_descriptor } from "./signal_descriptor_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/graph/signal_binding.proto.
 */
export const file_mochabugapis_adapt_graph_signal_binding: GenFile = /*@__PURE__*/
  fileDesc("Ci1tb2NoYWJ1Z2FwaXMvYWRhcHQvZ3JhcGgvc2lnbmFsX2JpbmRpbmcucHJvdG8SGG1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaCLvAgoNU2lnbmFsQmluZGluZxJGCgpkZXNjcmlwdG9yGAEgASgLMioubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLlNpZ25hbERlc2NyaXB0b3JCBrpIA8gBARIdCglyZWZlcmVuY2UYAiABKAlCCLpIBXIDGPoBSAASKgoIY29uc3RhbnQYAyABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWVIABJOCgVlcnJvchgEIAEoDjItLm1vY2hhYnVnYXBpcy5hZGFwdC5ncmFwaC5TaWduYWxCaW5kaW5nLkVycm9yQgu6SAjYAQGCAQIgAEgBiAEBImYKBUVycm9yEhUKEUVSUk9SX1VOU1BFQ0lGSUVEEAASEQoNRVJST1JfVU5CT1VORBABEhgKFEVSUk9SX0lOVkFMSURfU09VUkNFEAISGQoVRVJST1JfU0NIRU1BX01JU01BVENIEANCCQoHYmluZGluZ0IICgZfZXJyb3JiBnByb3RvMw", [file_buf_validate_validate, file_google_protobuf_struct, file_mochabugapis_adapt_graph_signal_descriptor]);

/**
 * Receiver represents an input point for a vertex, which can bind
 * to multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.SignalBinding
 */
export type SignalBinding = Message<"mochabugapis.adapt.graph.SignalBinding"> & {
  /**
   * The actual signal descriptor.
   *
   * @generated from field: mochabugapis.adapt.graph.SignalDescriptor descriptor = 1;
   */
  descriptor?: SignalDescriptor;

  /**
   * The binding can be a reference to another signal or a constant value.
   * not required to be set if the descriptor is optional
   *
   * @generated from oneof mochabugapis.adapt.graph.SignalBinding.binding
   */
  binding: {
    /**
     * A reference to another signal <vertexid>:<transmitter>:<signal>
     *
     * @generated from field: string reference = 2;
     */
    value: string;
    case: "reference";
  } | {
    /**
     * A constant value (must validate against the descriptor)
     *
     * @generated from field: google.protobuf.Value constant = 3;
     */
    value: Value;
    case: "constant";
  } | { case: undefined; value?: undefined };

  /**
   * The binding may also have one of the 3 error codes
   *
   * @generated from field: optional mochabugapis.adapt.graph.SignalBinding.Error error = 4;
   */
  error?: SignalBinding_Error;
};

/**
 * Receiver represents an input point for a vertex, which can bind
 * to multiple signals.
 *
 * @generated from message mochabugapis.adapt.graph.SignalBinding
 */
export type SignalBindingJson = {
  /**
   * The actual signal descriptor.
   *
   * @generated from field: mochabugapis.adapt.graph.SignalDescriptor descriptor = 1;
   */
  descriptor?: SignalDescriptorJson;

  /**
   * A reference to another signal <vertexid>:<transmitter>:<signal>
   *
   * @generated from field: string reference = 2;
   */
  reference?: string;

  /**
   * A constant value (must validate against the descriptor)
   *
   * @generated from field: google.protobuf.Value constant = 3;
   */
  constant?: ValueJson;

  /**
   * The binding may also have one of the 3 error codes
   *
   * @generated from field: optional mochabugapis.adapt.graph.SignalBinding.Error error = 4;
   */
  error?: SignalBinding_ErrorJson;
};

/**
 * Describes the message mochabugapis.adapt.graph.SignalBinding.
 * Use `create(SignalBindingSchema)` to create a new message.
 */
export const SignalBindingSchema: GenMessage<SignalBinding, {jsonType: SignalBindingJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_graph_signal_binding, 0);

/**
 * Some error codes that can appear on the binding
 *
 * @generated from enum mochabugapis.adapt.graph.SignalBinding.Error
 */
export enum SignalBinding_Error {
  /**
   * Not specified
   *
   * @generated from enum value: ERROR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Binding is missing, the signal is unbound even though the descriptor requires it to be bound
   *
   * @generated from enum value: ERROR_UNBOUND = 1;
   */
  UNBOUND = 1,

  /**
   * The source does not exist
   *
   * @generated from enum value: ERROR_INVALID_SOURCE = 2;
   */
  INVALID_SOURCE = 2,

  /**
   * The schema does not match, the source is valid
   *
   * @generated from enum value: ERROR_SCHEMA_MISMATCH = 3;
   */
  SCHEMA_MISMATCH = 3,
}

/**
 * Some error codes that can appear on the binding
 *
 * @generated from enum mochabugapis.adapt.graph.SignalBinding.Error
 */
export type SignalBinding_ErrorJson = "ERROR_UNSPECIFIED" | "ERROR_UNBOUND" | "ERROR_INVALID_SOURCE" | "ERROR_SCHEMA_MISMATCH";

/**
 * Describes the enum mochabugapis.adapt.graph.SignalBinding.Error.
 */
export const SignalBinding_ErrorSchema: GenEnum<SignalBinding_Error, SignalBinding_ErrorJson> = /*@__PURE__*/
  enumDesc(file_mochabugapis_adapt_graph_signal_binding, 0, 0);

